import ArticleItem from '@/components/article-item'
// import AvatarTooltip from './avatar-tooltip'
import skeletonLoad from '@/components/skeletonLoad'
import ArticleDialog from '@/components/article-dialog/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Empty from '@/components/empty/index.vue'
// 移动端信息流列表（首页 / 同校列表在 <768px 时替换掉桌面单列卡片，结构一致、尺寸重排）
import MobileFeed from '@/components/article-item/MobileFeed.vue'
// 全站统一的图片组件：CDN 缩略图 + 三级降级 + 加载时机，见组件内注释
import SmartImg from '@/components/smart-img/index.vue'
// 学校认证角标：昵称出现的地方都可能要挂，做成全局组件省去逐个 import
import VerifiedBadge from '@/components/verified-badge/index.vue'
const components = {
  ArticleItem,
  skeletonLoad,
  ArticleDialog,
  syPagination: Pagination,
  syEmpty: Empty,
  MobileFeed,
  SmartImg,
  VerifiedBadge
  // AvatarTooltip
}

export default {
  install (Vue) {
    Object.keys(components).forEach(key => {
      Vue.component(key, components[key])
    })
  }
}
